export { default } from './RatingStars';



// WEBPACK FOOTER //
// ./src/components/Rating/RatingStars/index.js